export const leadStatus = {
  pending: 'pending',
  lead: 'lead',
  appointment: 'appointment',
  pendingNoApt: 'pending-no-apt', // when using to collect leads instead of make appointments
  leadNoApt: 'lead-no-apt', // when using to collect leads instead of make appointments
  contactError: 'contact-error',
  // LeadPerfection orgs only: the /lead submit call returns this immediately instead of blocking
  // on the CRM lookup. The front end then polls GET .../lead-status until it resolves to one of
  // the statuses above (or falls back to leadNoApt if the backend gives up waiting on the CRM).
  crmPending: 'crm-pending'
};
